export const LSK_RatesheetsApiToken = 'RATESHEETS_API_TOKEN';
export const LSK_RatesheetsApiPass = 'RATESHEETS_API_PASS';
export const LSK_RatesheetsApiCredentialsId = 'RATESHEETS_API_CREDENTIALS_ID';
